/**
* Treatment Video JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Video component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'treatment-video',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $componentHeight = $( '.get-height' ).height();
      $( '.treatment-video .outer' ).height( $componentHeight );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-video', COMPONENT );
} )( app );
